export default {
  name: 'backTop',
  data() {
    return {};
  }
};